export const POPUP_MODE = {
  customMode: 'custom_mode',
  importAd: 'import_ad',
};

export const POPUP_STEP = {
  loading: 'loading',

  connect: 'connect',
  accountSelection: 'account_selection',
  adsSelection: 'ads_selection',
};

export const DAYS_COUNT_CUSTOM_MODE = 90;
export const DAYS_COUNT_IMPORT_AD = 30;

export const getAdsDaysCount = (mode) =>
  mode === POPUP_MODE.importAd ? DAYS_COUNT_IMPORT_AD : DAYS_COUNT_CUSTOM_MODE;

export const AD_FIELD = {
  text: 'text',
  impressions: 'impressions',
  ctr: 'ctr',
};
